<template>
    <div style="position: absolute;top:0;width: 100%;z-index: 3">
      <nav class="navbar bg-primary">
        <div class="orioc-container box">
            <div  class="topbar-nav">
              <a href="">
              <img style="height: 35px;margin-top: 17.5px;"  src="../../../static/img/logo_yfw.png" alt="">
              </a>
            </div>

          <div class="collapse navbar-collapse topbar-cart">
          </div>

          <div class="collapse navbar-collapse topbar-info">
             <ul class="navbar-ul login_right">
             </ul>
          </div>
        </div>
      </nav>
    </div>

</template>

<script>
  export default {
    name: "index",
    methods:{

    }
  }
</script>

<style lang="scss" scoped>


  .box:after {
    clear: both;
  }
  .box:before, .box:after {
    content: " ";
    display: table;
  }
  .topbar-nav{
    display: block;
  }
  .topbar-nav,.topbar-cart{
    float:left;
  }
  .topbar-cart{
    padding-left: 10%;
  }
  .topbar-info{
    float:right;
  }
  .navbar-ul{
    .li-item{
      float: left;
      .nav-link{
        padding:0 15px;
        font-size: 14px;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:70px;
        height: 70px;
        display: block;
        cursor: pointer;
      }

    }
  }
.login_right{
  float: right;
}
  .login_btn{
    /*background: #1B91FF;*/
    background: none;
    color: #fff;
    border:none;
    font-size: 14px;
    font-weight: 500;
    padding: 5px 15px;
    border-radius: 4px;
    cursor: pointer;
  }
  .login_btn:hover{
    /*background: #56adff;*/
  }
  .registered_btn{
    /*border-radius: 4px;*/
    /*color: rgba(0,0,0,0.65);*/
    /*background-color:  rgba(0,0,0,0);*/
    /*border-color: #d9d9d9;*/
    font-size: 14px;
    font-weight: 500;
    padding: 5px 15px;
    cursor: pointer;
    background: none;
    border: none;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar/index.vue